import { Injectable } from '@angular/core';
import { LocaleService } from './locale-service';
import { DateTime, Settings } from 'luxon';

@Injectable({ providedIn: 'root' })
export class DateTimeAdapterService {
    constructor(private localeService: LocaleService) {
        this.localeService.onLocaleChange.subscribe((e) => {
            Settings.defaultLocale = e;
        });

        Settings.defaultLocale = this.localeService.currentLocale;
    }

    now(): DateTime {
        return DateTime.now().setLocale(Settings.defaultLocale);
    }

    fromISO(iso: string): DateTime {
        return DateTime.fromISO(iso).setLocale(Settings.defaultLocale);
    }

    format(date: DateTime, format: Intl.DateTimeFormatOptions | string = DateTime.DATE_FULL): string {
        return date.setLocale(Settings.defaultLocale).toLocaleString(format as any);
    }

    getLastNDaysLabels(days = 30): string[] {
        const now = this.now();
        const currentYear = now.year;

        return Array.from({ length: days }, (_, i) => {
            const date = now.minus({ days: i });
            const format: Intl.DateTimeFormatOptions =
                date.year === currentYear
                    ? { day: 'numeric', month: 'short' }
                    : { day: 'numeric', month: 'short', year: 'numeric' };

            return this.format(date, format);
        }).reverse();
    }
}
